import { ABP, eLayoutType } from '@abp/ng.core';

export const TERMINAL_PAYMENT_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/terminal-payments',
    iconClass: 'fas fa-file-alt',
    name: '::Menu:TerminalPayments',
    layout: eLayoutType.application,
    requiredPolicy: 'Mandir.TerminalPayments',
    breadcrumbText: '::TerminalPayments',
  },
];
